import React, { useState, useEffect } from 'react';
import ActionButtonCard from '../Button/ActionButtonCard';
import Swal from 'sweetalert2'
import { Form, Button, Card, InputGroup, FormControl } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';


const IntervalosSelect = ({intervaloId, setIntervaloId, defaultText, label, adicionalText, adicionalValue, multiplos}) => {
  const [intervalos, setIntervalos] = useState([]);
  const [intervalosSelecionados, setIntervalosSelecionados] = useState([]);

  const { 
    salvarDados,
    buscarDados,
    buscarDadosPorId,
    excluirDadosPorId,
    crudAdmin,
    hasPerms,
  } = useProvider();
  const { get } = crudAdmin || {};
  
  useEffect(() => {
    const ids = intervaloId.map(id => parseInt(id, 10));
  
    setIntervalosSelecionados(
      intervalos.filter(x => ids.includes(x.id))
    );
  }, [intervaloId, intervalos]);

  const buscarIntervalos = async () => {
    try{
      const response = await get(`/core/intervalos/?ordering=dias,vezes`, 'intervalosSelect');
      if (response && response.length){
        const lista = response[0].results;
        setIntervalos(lista);
      }
    }catch(err){

    }finally{
      
    }
  };
  
  const listarDias =(intervalos) => {
    if (!intervalos || !intervalos.length) return [];
  
    const templates = [];
  
    // Separar intervalos 1x e >1x
    const intervalos1x = intervalos.filter(i => i.vezes === 1).sort((a, b) => a.dias - b.dias);
    const intervalosX  = intervalos.filter(i => i.vezes > 1).sort((a, b) => a.dias - b.dias);
  
    // Processa 1x fixos
    let ultimoDia = 0;
    for (const i of intervalos1x) {
      templates.push(i.dias);
      ultimoDia = Math.max(ultimoDia, i.dias);
    }
  
    // Processa >1x obedecendo hierarquia
    for (let idx = 0; idx < intervalosX.length; idx++) {
      const i = intervalosX[idx];
      const proximo = idx + 1 < intervalosX.length ? intervalosX[idx + 1] : null;
  
      // Primeira entrada acumulada a partir do último dia usado
      let dia = ultimoDia + i.dias;
      templates.push(dia);
  
      let repeticoes = 1;
      while (repeticoes < i.vezes) {
        dia += i.dias;
        // Bloqueia se o próximo nível pode entrar
        if (proximo && dia >= ultimoDia + proximo.dias) break;
        templates.push(dia);
        repeticoes++;
      }
  
      ultimoDia = Math.max(ultimoDia, dia);
    }
  
    return templates;
  }


  useEffect(() => {
    buscarIntervalos();
  }, []);
  
  const renderIntervalo = (intervalos) => {
    return intervalos.map(cat => {
      return (
        <React.Fragment key={cat.id}>
          {/* prefixo para indicar nível */}
          <option value={cat.id}>
            {`${cat.dias_text}`}
          </option>
        </React.Fragment>
      );
    });
  };
  
  //alert(JSON.stringify(intervaloId))


  return (
    <>
      <Form.Group controlId="formIntervalo" className="mt-3">
        <div className="input-group">
          <span className="input-group-text">{label || 'Intervalo'}</span>
          <Form.Control
            as="select"
            value={intervaloId}
            multiple={multiplos}
            onChange={(e) => {
              if (multiplos) {
                const values = Array.from(e.target.selectedOptions, opt => opt.value);
                setIntervaloId(values);
              } else {
                setIntervaloId(e.target.value);
              }
            }}
          >
            {!multiplos && (
              <option value="">{defaultText}</option>
            )}
            
            {renderIntervalo(intervalos)}

            {adicionalText && (
              <option value={adicionalValue}>
                {adicionalText || 'Categoria Adicional'}
              </option>
            )}
          </Form.Control>
        </div>
        <div>Dias após: {listarDias(intervalosSelecionados).join(', ')}</div>
      </Form.Group>
    </>
  );
}

export default IntervalosSelect;
